import React from 'react';

const SvgArrowDownOutline = props => (
  <svg width={13} height={7} {...props}>
    <path
      d="M6.5 5.58L11.982.172c.233-.23.61-.23.843 0a.583.583 0 0 1 0 .832L6.922 6.828a.602.602 0 0 1-.844 0L.175 1.004a.583.583 0 0 1 0-.832c.233-.23.61-.23.843 0L6.5 5.58z"
      fill="#046FE2"
      fillRule="nonzero"
    />
  </svg>
);

export default SvgArrowDownOutline;
